import React from "react";

function FestivalIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g clipPath="url(#clip0_899_1337)">
        <mask
          id="mask0_899_1337"
          style={{ maskType: "luminance" }}
          width="16"
          height="16"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path fill="#fff" d="M0 0h16v15.904H0V0z"></path>
        </mask>
        <g mask="url(#mask0_899_1337)">
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M3.647 6.81L.62 3.705c-.873-.9-.827-2.39.157-3.228.842-.73 2.137-.59 2.917.202l.312.326.297-.326c.781-.792 2.06-.932 2.935-.202a2.232 2.232 0 01.14 3.228L4.366 6.81a.502.502 0 01-.719 0zm10.112 4.6H15.5c.21 0 .394.155.44.351a.44.44 0 01-.112.547l-4 3.481c-.175.128-.434.165-.622.028a.492.492 0 01-.165-.597l1.2-2.816H10.5c-.21 0-.395-.1-.47-.295a.547.547 0 01.141-.575l4-3.48a.537.537 0 01.622 0 .496.496 0 01.165.596l-1.2 2.76zm-9.287-.249c-.8 0-1.5.696-1.5 1.492 0 .852.7 1.492 1.5 1.492.856 0 1.5-.64 1.5-1.492 0-.796-.644-1.492-1.5-1.492zm-2.139-1.74l.37-.526c.185-.276.497-.469.831-.469h1.932c.334 0 .647.193.83.47l.37.525h.806c.856 0 1.5.696 1.5 1.492v3.48c0 .852-.644 1.492-1.5 1.492h-6c-.8 0-1.472-.64-1.472-1.491v-3.482c0-.795.672-1.491 1.472-1.491h.861zM15.634.225A.981.981 0 0116 .967v4.475c0 .852-.897 1.492-2.028 1.492-1.075 0-2-.64-2-1.492 0-.795.925-1.492 2-1.492V2.208l-3 .596v3.633c0 .851-.869 1.492-2 1.492-1.075 0-2-.64-2-1.492 0-.796.925-1.492 2-1.492V1.961c0-.446.366-.854.831-.947l5-.995c.294-.058.6.017.831.206z"
            clipRule="evenodd"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_899_1337">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default React.memo(FestivalIcon);
